import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { InputRow, MultiCombobox } from '@/components/ui/form';
    import { useEmployeeData } from '@/composables/useEmployeeData';
    import { computed, watch } from 'vue';
    import { useI18n } from 'vue-i18n';
    import type { SelectOption, UserGroup } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UserCompanyForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

    const { employeesAndGroups, isPlaceholderDataEmployeesAndGroups } = useEmployeeData(
        props.form.company_id,
    );

    const keepers = computed(() => {
        return employeesAndGroups.value.keepers || [];
    });

    const userGroups = computed(() => {
        return employeesAndGroups.value.user_groups || [];
    });

    const employeesAndGroupsOptions = computed<SelectOption[]>(() => {
        const hasGroups = !!userGroups.value.length;
        const hasEmployees = !!keepers.value.length;

        const makeGroup = (
            labelKey: string,
            entries: any[],
            addon: string = '',
            prefix: string = '',
        ) => [
            { is_group: true, label: t(labelKey), value: '' },
            ...entries.map((obj) => ({
                value: prefix + obj.id,
                label: obj.name,
                addon,
            })),
        ];

        const options: SelectOption[] = [];
        if (hasGroups)
            options.push(...makeGroup('user-groups.groups', userGroups.value, 'userGroup', 'ug-'));
        if (hasGroups && hasEmployees) options.push({ is_seperator: true, value: '', label: '' });
        if (hasEmployees) options.push(...makeGroup('user-groups.employees', keepers.value));

        return options;
    });

    watch(
        () => props.form.user_ids,
        (newVal, oldVal) => {
            if (!oldVal) return;

            const oldSelectedGroups = oldVal.filter((id: string) => id.startsWith('ug-'));
            const selectedGroups = newVal.filter((id: string) => id.startsWith('ug-'));
            const userIds = newVal.filter((id: string) => !id.startsWith('ug-'));

            const groupUserIds = selectedGroups.flatMap((groupId: string) => {
                const group = userGroups.value.find(
                    (g: UserGroup) => g.id.toString() === groupId.replace('ug-', ''),
                );
                return group ? group.usersIds.map((uid: number[]) => uid.toString()) : [];
            });

            const oldGroupUserIds = oldSelectedGroups.flatMap((groupId: string) => {
                const group = userGroups.value.find(
                    (g: UserGroup) => g.id.toString() === groupId.replace('ug-', ''),
                );
                return group ? group.usersIds.map((uid: number[]) => uid.toString()) : [];
            });

            const currentUserIds: string[] = [
                ...userIds,
                ...groupUserIds.filter((id: string) => !oldGroupUserIds.includes(id)),
            ].filter((id) => !oldGroupUserIds.includes(id) || groupUserIds.includes(id));

            const finalSet = new Set([...selectedGroups, ...currentUserIds]);

            const updated = Array.from(finalSet);

            if (JSON.stringify(updated) !== JSON.stringify(newVal)) {
                props.form.user_ids = updated;
            }
        },
        { deep: true },
    );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("span", { tabindex: "0" }, null, -1)),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "user_ids",
      label: "companies.user_companies_edit"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MultiCombobox), {
          modelValue: _ctx.form.user_ids,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.user_ids) = $event)),
          options: employeesAndGroupsOptions.value,
          translate: false,
          placeholder: _unref(t)('companies.user_companies_edit'),
          loading: _unref(isPlaceholderDataEmployeesAndGroups),
          "show-addon": false
        }, null, 8, ["modelValue", "options", "placeholder", "loading"])
      ]),
      _: 1
    }, 8, ["form"])
  ], 64))
}
}

})